import type { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';

export interface LegalsFooterColorsView {
  backgroundColor?: IContentBuilderFieldColor | string;
  borderColor?: IContentBuilderFieldColor | string;
  logoColor?: 'light' | 'dark';
}

/** CB2 props use snake_case; doodBlockConfig defaults use camelCase in the same group. */
export function resolveLegalsFooterColorsView(raw: unknown): LegalsFooterColorsView {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }
  const colors = raw as Record<string, unknown>;
  return {
    backgroundColor: (colors['background_color'] ?? colors['backgroundColor']) as
      | IContentBuilderFieldColor
      | string
      | undefined,
    borderColor: (colors['border_color'] ?? colors['borderColor']) as
      | IContentBuilderFieldColor
      | string
      | undefined,
    logoColor: (colors['logo_color'] ?? colors['logoColor']) as 'light' | 'dark' | undefined,
  };
}
